import * as React from 'react';
import DropdownField, { IDropdownFieldProps } from './dropdown_field/dropdown_field';

const styles = require('./pik_dropdown.css');

export class HackedDropdown extends DropdownField {
  public constructor(props: IDropdownFieldProps) {
    super(props);
  }
}

export class PikDropdown extends React.PureComponent<IDropdownFieldProps, object> {
  public render() {
    const popupStyle = this.props.values && this.props.values.length ? undefined : styles['popup-hidden'];

    return (
      <HackedDropdown
        valueSelectedStyle={styles['single-value-selected']}
        valueActiveStyle={styles['multi-value-selected']}
        buttonStyle={styles['button']}
        popupStyle={popupStyle}
        {...this.props}
      />
    );
  }
}
